import type { Discrepancy } from "@/types/ezyvet";

/** Previous and next ids around `id` in the pending queue; the queue's first item when `id` has left it. */
export function neighbours(queue: Discrepancy[] | undefined, id: string): { index: number; prev?: string; next?: string } {
  if (!queue?.length) return { index: -1 };
  const index = queue.findIndex((d) => d.id === id);
  if (index < 0) return { index, next: queue[0]?.id };
  return { index, prev: queue[index - 1]?.id, next: queue[index + 1]?.id };
}

/** Keyboard shortcuts should not fire while the user is typing. */
export function isTyping(target: EventTarget | null): boolean {
  const el = target as HTMLElement | null;
  if (!el) return false;
  return el.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName);
}
